/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { userListConfig } from '../../config/pendingPayments.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { GET_PENDING_PAYMENTS } from '../../api/graphql';
import { APPLICATION_TYPE } from '@/config/applicationType.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface IPendingPaymentMethods extends IPluginMethodMap {
  getPendingPayments(args: any): Promise<any>;
}

export class PendingPaymentService implements IAgentPlugin {
  readonly methods: IPendingPaymentMethods;

  constructor() {
    this.methods = {
      getPendingPayments: this.getPendingPayments.bind(this),
    };
  }

  private async getPendingPayments(args: any) {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const userProfile = storageService.get('myProfile', 'session');
    const role = userProfile?.org?.orgRole;

    const whoAmI =
      userData?.currentRole ??
      (userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : null);
    const roetable = [
      {
        column: 'type',
        op: 'In',
        value: ['CARICOM_NEW_WORK_PERMIT','CARICOM_RENEW_WORK_PERMIT'],
      },
    ];
    const statusValue =
      whoAmI === 'prospective_employee'
        ? ['READY_TO_PAY']
        : ['READY_TO_PAY', 'WAITING_FOR_WP_FEE'];
    const typeNotIn =
      whoAmI === 'prospective_employee'
        ? ['NEW_WORK_PERMIT', 'RENEW_WORK_PERMIT']
        : [
            'CSME_VERIFICATION',
            'NEW_CSME_CERTIFICATE',
            'RENEW_CSME_CERTIFICATE',
            'MARRIAGE_EXEMPTION',
          ];
    console.log('hi->', args);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const where =
        args?.where?.length > 1
          ? args?.where
          : [
              ...(args?.where ?? []),
              ...(role === 'CARICOM_BUSSINESS_ORG' ? roetable : []),
              {
                column: 'status',
                op: 'In',
                value: statusValue,
              },
              {
                column: 'type',
                op: 'NotIn',
                value: typeNotIn,
              },
            ];
      if (client) {
        const res = await client.query(GET_PENDING_PAYMENTS, {
          input: {
            skip: args?.offset,
            limit: args?.size,
            where: where,
            order: [
              {
                column: 'updatedAt',
                direction: 'DESC',
              },
            ],
          },
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatUserTable(
            res?.data?.getListOfApplication?.data
          );
          console.log(`row data`, _rowData);
          return {
            ...userListConfig,
            ultUsers: _rowData,
            userRoles: res?.data?.getRoleList?.data,
            isEmpty: _rowData
              ? res?.data?.getListOfApplication?.data?.length <= 0
              : true,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfApplication?.currentPage,
            pageSize: res?.data?.getListOfApplication?.pageSize,
            totalCount: res?.data?.getListOfApplication?.totalCount,
            totalPages: res?.data?.getListOfApplication?.totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any, index: number) => {
        return {
          id: item?.applicationNo,
          // status: item?.status,
          name: item?.applicantInfo?.firstName
            ? `${
                item?.applicantInfo?.lastName
                  ? toHeaderCase(item?.applicantInfo?.lastName ?? '')
                  : ''
              }, ${toHeaderCase(item?.applicantInfo?.firstName)}`
            : //  ${
              //     item?.applicantInfo?.middleName
              //       ? toHeaderCase(item?.applicantInfo?.middleName ?? '')
              //       : ''
              //   }`
              '',

          appliedOn: this.formatCreatedDate(item?.createdAt) ?? '-',
          status: this.getFormattedStatus(item?.status),
          type: this.getFormattedType(item?.type),
          applicationId: item?.applicationNo,
          nationality: item?.applicantInfo?.nationality ?? '-',
          //need to change
          applicationCompletedOn:
            this.formatCreatedDate(item?.completedOn) ?? '-',
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }

  private getFormattedType(type: string) {
    if (APPLICATION_TYPE?.[type]) {
      return APPLICATION_TYPE?.[type];
    }
    return '-';
  }

  private getFormattedStatus(status: string) {
    if (status) {
      switch (status) {
        case 'READY_TO_PAY':
          return 'Processing Fee';
        case 'WAITING_FOR_WP_FEE':
          return 'Work Permit Fee';
        default:
          return '-';
      }
    }
  }
}
